import React from "react";
import SourcingListContent from "../components/sourcing/sourcing-list-content";

const SourcingList = () => {
  return <SourcingListContent />;
};

export default SourcingList;
